import React from "react";
import {Website} from "../layouts/Website";
import {Box, Container, Typography} from "@mui/material";
import {PageTitle} from "../components/shared/PageTitle";
import {contactsMap} from "../data/contactsMap";

export const Contacts = () => {
    return (
        <Website>
            <Container sx={{pb: 2, pt: 6}}>
                <PageTitle title={'contatti'} image={'icon-contacts'}/>
                <Typography sx={{ py:1, color:'#000'}} fontWeight={'bold'} variant={'h6'}>
                    Numeri attivi dal 12 al 14 Marzo 2025
                </Typography>
                <Box>
                    {
                        contactsMap.map((contact, index) =>
                            <Box key={index} sx={{py:1, mb:4}}>
                                <Typography variant={'h6'} fontWeight={'bold'} color={'#d1112c'}>
                                    {contact.title}
                                </Typography>
                                {contact.description && <Typography>
                                    {contact.description}
                                </Typography>}
                                {
                                    contact.list &&
                                    <ul style={{marginBlock:0}}>
                                        {contact.list.map((item, index) =>
                                            <li key={index}>
                                                <Typography>
                                                    {item}
                                                </Typography>
                                            </li>
                                        )}
                                    </ul>
                                }
                            </Box>
                        )
                    }
                </Box>
            </Container>
        </Website>
    )
}
